import { ButtonGroup } from "@wayflyer/flyui";
import { useState } from "react";
import { useIntl } from "react-intl";

import { COMMON_MESSAGES } from "../../../components/common-messages";
import { PAGE_TYPE, useFundingApplicationNavigation } from "../../../hooks/navigation-next";

type DocumentNavigationGroupProps = {
  isStepComplete: boolean;
  forType: string;
  onPrimaryAction?: () => void;
  onSecondaryAction?: () => void;
  onTertiaryAction?: () => void;
};

export const DocumentNavigationGroup = ({
  isStepComplete,
  forType,
  onPrimaryAction,
  onSecondaryAction,
  onTertiaryAction,
}: DocumentNavigationGroupProps) => {
  const navigationContext = useFundingApplicationNavigation({
    currentPage: PAGE_TYPE.DOCUMENTS,
    currentStep: forType,
  });
  const [isPrimarySubmitting, setIsPrimarySubmitting] = useState(false);
  const [isTertiarySubmitting, setIsTertiarySubmitting] = useState(false);
  const intl = useIntl();

  return (
    <ButtonGroup
      primaryAction={{
        onAction: async () => {
          if (navigationContext.nextPath) {
            setIsPrimarySubmitting(true);
            await navigationContext.navigateWithStateUpdate(navigationContext.nextPath);
            setIsPrimarySubmitting(false);
          }
          onPrimaryAction?.();
        },
        content: intl.formatMessage(COMMON_MESSAGES.nextLabel),
        disabled: !isStepComplete,
        loading: isPrimarySubmitting,
        analyticsId: "document-uploads-next-button",
      }}
      secondaryAction={{
        onAction: () => {
          if (navigationContext.previousPath) {
            navigationContext.navigate(navigationContext.previousPath);
          }
          onSecondaryAction?.();
        },
        content: intl.formatMessage(COMMON_MESSAGES.backLabel),
        analyticsId: "document-uploads-back-button",
      }}
      tertiaryAction={{
        onAction: async () => {
          if (navigationContext.nextPath) {
            setIsTertiarySubmitting(true);
            await navigationContext.navigateWithStateUpdate(navigationContext.nextPath);
            setIsTertiarySubmitting(false);
          }
          onTertiaryAction?.();
        },
        content: intl.formatMessage(COMMON_MESSAGES.skipLabel),
        disabled: isStepComplete,
        loading: isTertiarySubmitting,
        analyticsId: "document-uploads-skip-button",
      }}
      primaryActionTestId="navigation-continue-button"
      secondaryActionTestId="navigation-back-button"
      tertiaryActionTestId="navigation-skip-button"
    />
  );
};
